import { Paper, Typography } from "@material-ui/core";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Autocomplete,
  Box,
  Checkbox,
  Grid,
  IconButton,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";
import axios from "axios";
import isoCountries from "i18n-iso-countries";
import jwt_decode from "jwt-decode";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ReactComponent as ProfileEditIcon } from "../../assets/ProfileEditIcon.svg";
import CustomPhone from "../../components/CustomInputs/CustomPhone";
import CustomTextfeild from "../../components/CustomInputs/CustomTextfield";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import HeaderToolbar from "../../components/HeaderToolbar";
import ProfileContext from "../../components/ProfileContext";
import Toast from "../../components/ToastContainer/CustomToast";
import { getCompanyById } from "../../slices/Company/CompanySlice";
import { getUserSettings } from "../../slices/User/UserSlice";
import {
  getUserInfoPro,
  updateUserInfoPro,
} from "../../slices/User/UserSlice1";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import { countryData, gender } from "../Person/AddressFormData";
import UploadUserProfile from "../Person/UploadUserProfile";

function UserProfile() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  var maxDate = new Date();
  const [phoneInput, setPhoneInput] = useState("");
  const [isMFAEnabled, setIsMFAEnabled] = useState(false);
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    dateOfBirth: CommonUtil.getDateOfJoining(maxDate),
    dateOfJoining: CommonUtil.getDateOfJoining(maxDate),
    gender: "",
    profilePhoto: "",
    email: "",
    phone: "",
    verified: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    pincode: "",
    country: "",
    id: "",
    phoneCountryCode: "",
    userProfiles: "",
    isMFAEnabled: "",
  });

  // const [photoFile, setPhotoFile] = useState('');

  const [error, setError] = useState({
    firstName: false,
    lastName: false,
    dateOfBirth: false,
    dateOfJoining: false,
    gender: false,
    profilePhoto: false,
    email: false,
    phone: false,
    verified: false,
    addressLine1: false,
    addressLine2: false,
    city: false,
    state: false,
    pincode: false,
    country: false,
    id: false,
  });

  const [profileImage, setProfileImage] = React.useState();
  const [profile, setProfile] = useState("");
  const [editMode, setEditMode] = useState(true);
  const [countries, setCountries] = React.useState([]);
  const [Gender, setGender] = React.useState([]);
  const [InavalidprofilePhoto, setInavalidprofilePhoto] = useState(false);
  const { setUserProfilePic } = useContext(ProfileContext);
  const { setUserProfile } = useContext(ProfileContext);
  const [selectedGender, setSelectedGender] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [country, setCountry] = useState("");
  const { darkMode } = useContext(ThemeContext);
  var decoded_jwtToken = jwt_decode(
    localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN)
  );

  useEffect(() => {
    getUserSetting();
    setCountries(countryData);
    setGender(gender);
    setInavalidprofilePhoto(false);
    loadData();
  }, []);

  const loadData = () => {
    dispatch(getUserInfoPro(decoded_jwtToken.userId))
      .unwrap()
      .then((data) => {
        if (data.code === "UASI0000" || data.code === "UASI0033") {
          setUser({
            ...user,
            ...data.data,
            phoneCountryCode: data.data.phone
              ? data.data.phone.split("-")[0]
              : "",
            phone: data.data.phone ? data.data.phone.split("-")[1] : "",
            userProfiles: data.data.imagePreSignedURL,
          });
          setPhoneInput(data.data.phone);
          setProfile(data.data.imagePreSignedURL);
          const selectedGender = gender.find(
            (gender) => gender.name === data.data.gender
          );
          setSelectedGender(selectedGender);
          const selectedCountry = countryData.find(
            (country) => country.name === data.data.country
          );
          setSelectedCountry(selectedCountry);
          if (data.data.phone === "" || data.data.phone === null) {
            loadCompany();
          }
        } else {
          setUser([]);
        }
      })
      .catch((er) => {});
  };
  const getUserSetting = () => {
    let data = {
      userId: decoded_jwtToken.userId,
      companyId: decoded_jwtToken.companyId,
    };
    dispatch(getUserSettings(data))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4071" && res.data) {
          setUser({
            ...user,
            isMFAEnabled: res.data.mfaenabled,
          });
          setIsMFAEnabled(res.data.mfaenabled);
        } else {
          setUser({
            ...user,
            isMFAEnabled: false,
          });
          setIsMFAEnabled(false);
        }
      });
  };

  const uploadProfilePhoto = (data) => {
    var bodyFormData = new FormData();
    bodyFormData.append("url", data.user.imagePreSignedURL);
    bodyFormData.append("file", profileImage);
    axios({
      method: "post",
      url: "/web/employee/profile",
      data: bodyFormData,
      Authorization: localStorage.getItem("VISJwtToken"),
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function(response) {
        // Toast("Profile Photo Saved", "success");
        setUserProfilePic(profile);
      })
      .catch(function(response) {});
  };

  const updateUser = () => {
    setUser({
      ...user,
      isMFAEnabled: isMFAEnabled,
    });
    dispatch(updateUserInfoPro(user))
      .unwrap()
      .then((data) => {
        if (data.code === "UASI0002") {
          if (!user.profilePhoto.isEmptyString) {
            uploadProfilePhoto(data.data);
            setUserProfile(user);
            loadData();
            getUserSetting();
          }
          Toast(data.message, "success");
        } else {
          Toast(data.message, "error");
        }
      })
      .catch((er) => {});
  };

  const handleProfile = (file) => {
    setUser({
      ...user,
      profilePhoto: user.firstName,
      userProfiles: file.base64,
    });
    setProfile(file.base64);
    setProfileImage(file.file);
  };

  const handleClickEdit = () => {
    setEditMode(editMode ? false : true);
  };

  const handleCheckBox = (event) => {
    setUser({
      ...user,
      isMFAEnabled: event.target.checked,
    });
    setIsMFAEnabled(event.target.checked);
  };

  const handleChange = (event) => {
    const name = event.target.name;
    setUser({
      ...user,
      [name]: event.target.value,
    });
    setError({
      [name]: false,
    });
  };

  const handleGenderChange = (event, value) => {
    setSelectedGender(value);
    setUser({
      ...user,
      gender: value.name,
    });
  };

  const handleCountryChange = (event, value) => {
    setSelectedCountry(value);
    setUser({
      ...user,
      country: value.name,
    });
  };

  const handlePhoneChange = (value, data, event, formattedValue) => {
    setPhoneInput(value);
    if (value === "") {
      setUser({
        ...user,
        phoneCountryCode: "",
        phone: "",
      });
    } else {
      setUser({
        ...user,
        phoneCountryCode: "+" + data.dialCode,
        phone: value.toString().replace(data.dialCode, ""),
      });
    }
    setError({ phone: false });
  };

  const loadCompany = () => {
    dispatch(getCompanyById(decoded_jwtToken.companyId))
      .unwrap()
      .then((data) => {
        if ((data.code = "UASI0026")) {
          const fullCountryName = data.data.country;
          const countryCode = getCountryCodeFromName(fullCountryName);
          if (countryCode) {
            setCountry(countryCode);
          } else {
            setCountry("us");
          }
        }
      })
      .catch((er) => {});
  };
  const getCountryCodeFromName = (countryName) => {
    const formattedCountryName = countryName
      .toLowerCase()
      .replace(/\b\w/g, (l) => l.toUpperCase());
    const countryCode = (
      isoCountries.getAlpha2Code(formattedCountryName, "en") || ""
    ).toLowerCase();
    return countryCode || null;
  };

  const onSubmit = () => {
    if (CommonUtil.isEmptyString(user.firstName)) {
      Toast(t("USERPROFSCREEN007"), "error");
      setError({ ...error, firstName: true });
      return false;
    }

    if (!CommonUtil.isValidName(user.firstName)) {
      Toast(t("FIRSTNAME"), "error");
      setError({ ...error, firstName: true });
      return;
    }

    if (CommonUtil.isEmptyString(user.email)) {
      setError({ ...error, email: true });
      Toast("EMAILVALIDATE", "error");
      return;
    }

    if (!CommonUtil.isValidEmails(user.email)) {
      setError({ ...error, email: true });
      Toast("DEALEREMAILERROR", "error");
      return;
    }
    if (!CommonUtil.isAlphaNumericSpace(user.pincode)) {
      Toast(t("BILLING_PINCODE_VALIDATION"), "error");
      setError({ ...error, pincode: true });
      return;
    }
    if (!InavalidprofilePhoto) {
      updateUser(user);
      setEditMode(true);
    } else {
      Toast("Image size should be less than 2MB", "error");
    }
  };

  const onCancel = () => {
    setEditMode(true);
    loadData();
  };

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  return (
    <>
      <Grid
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ marginBottom: "8px" }}>
          <HeaderToolbar title={t("commonsUserProfile")} back_button={true} />
        </Box>
        <Grid>
          <div
            style={{
              backgroundColor: darkMode ? "#0E2A41" : "#F2F2F6",
              marginRight: "0px",
              borderRadius: "50%",
            }}
          >
            <IconButton
              onClick={handleClickEdit}
              sx={{
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <Tooltip
                title={
                  <Typography fontSize={12} fontWeight={500}>
                    {t("COMMON005")}
                  </Typography>
                }
              >
                {<ProfileEditIcon className="profileEditIcon" />}
              </Tooltip>
            </IconButton>
          </div>
        </Grid>
      </Grid>
      <Paper
        style={{
          backgroundColor: darkMode ? "#0E2A41" : "#fff",
          marginTop: "6px",
          overflowY: "auto",
          height: "calc(100vh - 160px)",
        }}
      >
        <Grid container p={3}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            md={4}
            sm={12}
          >
            <Grid xl={6}>
              <UploadUserProfile
                onsetProfile={(profile) => handleProfile(profile)}
                profilePhoto={profile}
                disabled={editMode}
              />
            </Grid>
          </Grid>
          <Grid container md={8} sm={12} spacing={2}>
            <Grid item xl={6} lg={6} md={6} sm={12}>
              <CustomTextfeild
                label={t("USER0001")}
                name={"firstName"}
                value={user.firstName}
                disabled={editMode}
                handleChange={handleChange}
                type={"text"}
                // validation='alpha-numeric'
                inputProps={{ maxLength: 25 }}
                required
                // inputColor={editMode ? 'red' : undefined}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12}>
              <CustomTextfeild
                label={t("COMMON021")}
                name={"lastName"}
                value={user.lastName}
                disabled={editMode}
                handleChange={handleChange}
                type={"text"}
                // validation='alpha-numeric'
                inputProps={{ maxLength: 25 }}
              />
            </Grid>

            <Grid item xl={6} lg={6} md={6} sm={12}>
              <Autocomplete
                popupIcon={<ExpandMoreIcon />}
                disabled={editMode}
                options={Gender}
                value={selectedGender}
                onChange={handleGenderChange}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t("USERPROFSCREEN011")}
                    sx={{
                      "& .MuiInputBase-input": {
                        color: darkMode ? "#fff" : "#0F273B", // Set text color based on dark mode
                      },
                      "& .MuiInputLabel-root": {
                        color: darkMode ? "#fff" : "#0F273B", // Set label color based on dark mode
                      },

                      "& .MuiInputBase-input.Mui-disabled": {
                        opacity: 1, // Ensure full visibility for disabled state
                        WebkitTextFillColor:
                          darkMode && editMode
                            ? "white" // Fix for WebKit browsers when darkMode is true and editMode is false
                            : "rgba(0, 0, 0, 0.38)", // Dark color for WebKit when darkMode is false or editMode is true
                      },
                      "& .MuiInputLabel-root.Mui-disabled": {
                        color: "#B3B3B3", // Label color for disabled state
                      },
                    }}
                  />
                )}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: darkMode ? "#fff" : "#b3adad", // Default border color
                    },
                    "&:hover fieldset": {
                      borderColor: darkMode ? "#fff" : "#434547", // Border color on hover
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: darkMode ? "#fff" : "#434547", // Border color when focused
                    },
                    "&.Mui-disabled fieldset": {
                      borderColor: "#B3B3B3", // Border color for disabled state
                    },
                    "& .MuiAutocomplete-clearIndicator": {
                      color: "#949596",
                    },
                    "& .MuiSvgIcon-root": {
                      color: "#949596",
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xl={6} lg={6} md={6} sm={12}>
              <CustomTextfeild
                label={t("COMMON042")}
                name={"email"}
                value={user.email}
                disabled={true}
                handleChange={handleChange}
                type={"text"}
                error={error.email}
                helperText={error.email}
                validation="email"
                required={user.id ? false : true}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12}>
              <CustomPhone
                placeholder="Mobile"
                disabled={editMode}
                value={phoneInput}
                label={"Mobile"}
                specialLabel={false}
                country={country}
                inputProps={{ maxLength: 12, style: { color: "red" } }}
                handleChange={(value, data, event, formattedValue) =>
                  handlePhoneChange(value, data, event, formattedValue)
                }
              />
            </Grid>

            <Grid item xl={6} lg={6} md={6} sm={12}>
              <CustomTextfeild
                label={t("ADD001")}
                name={"addressLine1"}
                value={user.addressLine1}
                disabled={editMode}
                handleChange={handleChange}
                type={"text"}
                error={error.addressLine1}
                helperText={error.addressLine1}
                // validation='alphabets'
                inputProps={{ maxLength: 50 }}
              />
            </Grid>

            <Grid item xl={6} lg={6} md={6} sm={12}>
              <CustomTextfeild
                label={t("ADD002")}
                name={"addressLine2"}
                value={user.addressLine2}
                disabled={editMode}
                handleChange={handleChange}
                error={error.addressLine2}
                helperText={error.addressLine2}
                // validation='alphabets'
                inputProps={{ maxLength: 50 }}
              />
            </Grid>

            <Grid item xl={6} lg={6} md={6} sm={12}>
              <CustomTextfeild
                label={t("ADD005")}
                name={"city"}
                value={user.city}
                disabled={editMode}
                handleChange={handleChange}
                type={"text"}
                error={error.city}
                helperText={error.city}
                validation="alphabets"
                inputProps={{ maxLength: 30 }}
              />
            </Grid>

            <Grid item xl={6} lg={6} md={6} sm={12}>
              <CustomTextfeild
                label={t("ADD004")}
                name={"state"}
                value={user.state}
                disabled={editMode}
                handleChange={handleChange}
                type={"text"}
                error={error.state}
                helperText={error.state}
                // validation='alphabets'
                inputProps={{ maxLength: 30 }}
              />
            </Grid>

            <Grid item xl={6} lg={6} md={6} sm={12}>
              <Autocomplete
                popupIcon={<ExpandMoreIcon />}
                disabled={editMode}
                options={countries}
                value={selectedCountry}
                onChange={handleCountryChange}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t("ADD003")}
                    sx={{
                      "& .MuiInputBase-input": {
                        color: darkMode ? "#fff" : "#0F273B", // Set text color based on dark mode
                      },
                      "& .MuiInputLabel-root": {
                        color: darkMode ? "#fff" : "#0F273B", // Set label color based on dark mode
                      },

                      "& .MuiInputBase-input.Mui-disabled": {
                        opacity: 1, // Ensure full visibility for disabled state
                        WebkitTextFillColor:
                          darkMode && editMode
                            ? "white" // Fix for WebKit browsers when darkMode is true and editMode is false
                            : "rgba(0, 0, 0, 0.38)", // Dark color for WebKit when darkMode is false or editMode is true
                      },
                      "& .MuiInputLabel-root.Mui-disabled": {
                        color: "#B3B3B3", // Label color for disabled state
                      },
                    }}
                  />
                )}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: darkMode ? "#fff" : "#b3adad", // Default border color
                    },
                    "&:hover fieldset": {
                      borderColor: darkMode ? "#fff" : "#434547", // Border color on hover
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: darkMode ? "#fff" : "#434547", // Border color when focused
                    },
                    "&.Mui-disabled fieldset": {
                      borderColor: "#B3B3B3", // Border color for disabled state
                    },
                    "& .MuiAutocomplete-clearIndicator": {
                      color: "#949596",
                    },
                    "& .MuiSvgIcon-root": {
                      color: "#949596",
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xl={6} lg={6} md={6} sm={12}>
              <CustomTextfeild
                label={t("DEALERZIPCODE")}
                name={"pincode"}
                value={user.pincode}
                disabled={editMode}
                handleChange={handleChange}
                type={"text"}
                inputProps={{ maxLength: 10 }}
              />
            </Grid>
            <Grid
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              style={{ paddingLeft: "4px" }}
            >
              <Stack direction="row">
                <Checkbox
                  sx={{
                    "&.Mui-checked": {
                      color: "rgb(242, 130, 76)",
                    },
                    color: "#949596",
                    "&.Mui-disabled": {
                      color: "#949596",
                    },
                  }}
                  checked={isMFAEnabled}
                  onChange={handleCheckBox}
                  disabled={editMode}
                />
                <Typography
                  style={{
                    alignContent: "center",
                    color: editMode
                      ? darkMode
                        ? "#576A7A"
                        : "rgb(0 0 0 / 38%)"
                      : darkMode
                      ? "white"
                      : "",
                  }}
                >
                  {t("TWO_FACTOR_AUTHENTICATION")}
                </Typography>
              </Stack>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid sm={4} item></Grid>
            {!editMode && (
              <Grid
                sm={8}
                item
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <Stack
                  direction={"row"}
                  spacing={2}
                  style={{
                    paddingRight: "12px",
                  }}
                >
                  <CancelButtons
                    disable={editMode}
                    variant="contained"
                    color="secondary"
                    onClick={onCancel}
                  >
                    <Typography>{t("COMMON008")}</Typography>
                  </CancelButtons>

                  <SubmitButtons
                    disable={editMode}
                    variant="contained"
                    onClick={onSubmit}
                  >
                    <Typography>{t("COMMON007")}</Typography>
                  </SubmitButtons>
                </Stack>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Paper>
    </>
  );
}

export default UserProfile;
